module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal-setting"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      maxHeight: _vm.isMaximized ? '70vh' : '450px'
    })
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("传单状态校验")]), _vm._v(" "), _c('div', {
    staticClass: "setting-item"
  }, [_c('div', [_c('span', [_vm._v("无需校验服务单流程即可下单")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-value": "true",
      "inactive-value": "false"
    },
    model: {
      value: (
        _vm.getConfigListItemByType('requireServiceContractCheck').value
      ),
      callback: function($$v) {
        _vm.$set(_vm.getConfigListItemByType('requireServiceContractCheck'), "value", $$v)
      },
      expression: "\n            getConfigListItemByType('requireServiceContractCheck').value\n          "
    }
  }), _vm._v(" "), (
    _vm.getConfigListItemByType('requireServiceContractCheck').value ===
    'true'
  ) ? _c('el-checkbox', {
    attrs: {
      "true-label": "true",
      "false-label": "false"
    },
    model: {
      value: (
        _vm.getConfigExtendsOneItemByType('requireServiceContractCheck').value
      ),
      callback: function($$v) {
        _vm.$set(_vm.getConfigExtendsOneItemByType('requireServiceContractCheck'), "value", $$v)
      },
      expression: "\n            getConfigExtendsOneItemByType('requireServiceContractCheck').value\n          "
    }
  }, [_vm._v("开放所有门店")]) : _vm._e(), _vm._v(" "), (
    _vm.getConfigExtendsOneItemByType('requireServiceContractCheck')
    .value === 'false' &&
    _vm.getConfigListItemByType('requireServiceContractCheck').value ===
    'true'
  ) ? _c('el-select', {
    attrs: {
      "size": "small",
      "value": _vm.getConfigExtendsOneItemShopIdsByType(
        'requireServiceContractCheck'
      ),
      "placeholder": "选择门店",
      "filterable": "",
      "multiple": "",
      "collapse-tags": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeShopByType($event, 'requireServiceContractCheck')
      }
    }
  }, _vm._l((_vm.shopOptions), function(item) {
    return _c('el-option', {
      key: item.shopId,
      attrs: {
        "label": item.shopName,
        "value": item.shopId
      }
    })
  }), 1) : _vm._e()], 1)]), _vm._v(" "), _c('mainContractNumberTag'), _vm._v(" "), (false) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("下单范围校验")]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "setting-item"
  }, [_c('div', [_c('span', [_vm._v("是否允许跨门店经营权限下单？")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-value": "true",
      "inactive-value": "false"
    },
    model: {
      value: (_vm.getConfigListItemByType('allowCrossStoreOrder').value),
      callback: function($$v) {
        _vm.$set(_vm.getConfigListItemByType('allowCrossStoreOrder'), "value", $$v)
      },
      expression: "getConfigListItemByType('allowCrossStoreOrder').value"
    }
  }), _vm._v(" "), (
    _vm.getConfigListItemByType('allowCrossStoreOrder').value === 'true'
  ) ? _c('el-checkbox', {
    attrs: {
      "true-label": "true",
      "false-label": "false"
    },
    model: {
      value: (
        _vm.getConfigExtendsOneItemByType('allowCrossStoreOrder').value
      ),
      callback: function($$v) {
        _vm.$set(_vm.getConfigExtendsOneItemByType('allowCrossStoreOrder'), "value", $$v)
      },
      expression: "\n            getConfigExtendsOneItemByType('allowCrossStoreOrder').value\n          "
    }
  }, [_vm._v("开放所有门店")]) : _vm._e(), _vm._v(" "), (
    _vm.getConfigExtendsOneItemByType('allowCrossStoreOrder').value ===
    'false' &&
    _vm.getConfigListItemByType('allowCrossStoreOrder').value === 'true'
  ) ? _c('el-select', {
    attrs: {
      "size": "small",
      "value": _vm.getConfigExtendsOneItemShopIdsByType('allowCrossStoreOrder'),
      "placeholder": "选择门店",
      "filterable": "",
      "multiple": "",
      "collapse-tags": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeShopByType($event, 'allowCrossStoreOrder')
      }
    }
  }, _vm._l((_vm.shopOptions), function(item) {
    return _c('el-option', {
      key: item.shopId,
      attrs: {
        "label": item.shopName,
        "value": item.shopId
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (
    _vm.getConfigListItemByType('allowCrossStoreOrder').value === 'true'
  ) ? _c('div', [_vm._v("\n          若选择为是，则下单时校验商场经营权限，不再根据门店限制下单范围\n        ")]) : _vm._e()], 1), _vm._v(" "), (
    _vm.getConfigListItemByType('allowCrossStoreOrder').value === 'true'
  ) ? _c('el-divider') : _vm._e(), _vm._v(" "), (
    _vm.getConfigListItemByType('allowCrossStoreOrder').value === 'true'
  ) ? _c('div', {
    staticClass: "org-channel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, _vm._l((_vm.orgChannelConfig), function(item) {
    return _c('div', {
      key: item.value
    }, [_c('span', [_vm._v(_vm._s(item.brandCategoryName))]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "配置招商渠道优先级",
        "value": _vm.getOrgChannelConfigHightestPriorityName(item),
        "size": "small"
      }
    }), _vm._v(" "), _c('el-link', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.handleOrgChannelConfig(item)
        }
      }
    }, [_vm._v("配置")])], 1)
  }), 0)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('CustomerDataPackageSetting', {
    key: _vm.componentKey,
    ref: "customerDataPackageRef"
  }), _vm._v(" "), _c('reviewOrderCondition', {
    key: _vm.componentKey + '_review',
    ref: "reviewOrderConditionRef"
  }), _vm._v(" "), _c('TransmissionPersonalizedSetting', {
    key: _vm.componentKey + '_transmission',
    ref: "transmissionPersonalizedRef"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1), _vm._v(" "), _c('orgChannelConfigDialog', {
    attrs: {
      "visible": _vm.isShowOrgChannelConfigDialog,
      "item": _vm.currentOrgChannelConfigItem
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowOrgChannelConfigDialog = $event
      },
      "confirm": _vm.handleOrgChannelConfirm
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("\n            商场存在同品牌品类多个招商渠道，请选择主合同号取号/下单时的招商渠道优先级\n          ")]), _vm._v(" "), _c('div', [_vm._v("（若门店已有的品牌品类则按门店关联的招商渠道取号）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc0a1900"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/functionSetting.vue
// module id = 2423
// module chunks = 68